module.exports = __webpack_public_path__ + "static/media/1Asset-15-100.51b038d5.jpg";